import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getApi } from 'service/axios'
import PIN_OPEN_ICON from 'assets/images/pin-large_open.png' // 운영중 - Station_State: 1
import PIN_STOP_ICON from 'assets/images/pin-large_stop.png' //중지 - Station_State: 3
import PIN_READY_ICON from 'assets/images/pin-large_ready.png' //준비중 - Station_State: 5
import { MAP_API_URL, RESULT_CODE, ROW_SIZE } from '../../service/ServiceUtils'
import { URL } from '../../utils/Utils'
import './NetworkGoStation.scss'
const { kakao } = window

/**
 * 23.05 고객지원 화면 리뉴얼 되면서 해당 파일 close
 * @file 고객지원 고스테이션 지도 화면
 */
function NetworkGoStation() {
    const [stationData, setStationData] = useState([]) //서버에서 가져온 station data
    const navigate = useNavigate()

    useEffect(() => {
        const fetchData = async () => {
            getApi(MAP_API_URL, { use_bit: 'Y', row_size: ROW_SIZE.ROW_9999, current_page: 1 })
                .then(res => {
                    if (res?.data?.result_code === RESULT_CODE.SUCESS) {
                        setStationData([...res?.data?.master])
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (stationData.length > 0) settingMap()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stationData])

    const settingMap = () => {
        let mapContainer = document.getElementById('map') //지도를 담을 영역의 DOM 레퍼런스
        let pinIcon

        let mapOption = {
            //지도를 생성할 때 필요한 기본 옵션
            center: new kakao.maps.LatLng(36.2683, 127.6358), // 지도의 중심좌표
            level: 11, // 지도의 확대 레벨
        }

        let map = new kakao.maps.Map(mapContainer, mapOption) //지도 생성 및 객체 리턴

        //#region  [ 마커 생성 로직 ]
        // STATION_INFO : 스테이션 위치 데이터를 json타입으로 저장한 변수
        for (let i = 0; i < stationData.length; i++) {
            // 마커 이미지의 이미지 크기 입니다
            let imageSize = new kakao.maps.Size(36, 44)
            let latlng = new kakao.maps.LatLng(stationData[i].Station_Lat, stationData[i].Station_Lon)

            if (Number(stationData[i].Station_State) === 1) {
                pinIcon = PIN_OPEN_ICON
            } else if (Number(stationData[i].Station_State) === 3) {
                pinIcon = PIN_STOP_ICON
            } else if (Number(stationData[i].Station_State) === 5) {
                pinIcon = PIN_READY_ICON
            }
            let markerImage = new kakao.maps.MarkerImage(pinIcon, imageSize)

            // 마커를 생성합니다
            let marker = new kakao.maps.Marker({
                map: map, // 마커를 표시할 지도
                position: latlng, // 마커를 표시할 위치
                title: stationData[i].Station_Name, // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
                image: markerImage, // 마커 이미지
                clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
            })

            let content =
                `<div class ="label" data-id="${stationData[i].Station_Name}" style="display: none"><span class="left"></span><span class="center">` +
                stationData[i].Station_Name +
                '</span><span class="right"></span></div>'

            // 마커 위에 커스텀오버레이를 표시합니다
            // 마커를 중심으로 커스텀 오버레이를 표시하기위해 CSS를 이용해 위치를 설정했습니다
            let overlay = new kakao.maps.CustomOverlay({
                content: content,
                map: map,
                zIndex: 6,
                position: marker.getPosition(),
            })
            overlay.setMap(map)

            /**
             * 마커 클릭시, 좌측 하단에 스테이션명, 스테이션 주소를 게시하는 돔 생성하는 콜백함수
             */
            const searchDetailAddrFromCoords = async () => {
                let allDom = document.querySelectorAll(`[data-id]`)
                for (let i = 0; i < allDom.length; i++) {
                    allDom[i].style.display = 'none'
                }
                var contentUpperSection = document.querySelector(`[data-id="${stationData[i]?.Station_Name}"]`)
                contentUpperSection.style.display = 'block'

                let mapDetails = document.querySelector('.map-details')
                if (!document.body.querySelector('.map-details')) {
                    mapDetails = document.createElement('div')
                    mapDetails.classList.add('map-details')
                    document.body.appendChild(mapDetails)
                }
                mapDetails.innerHTML = `<div class="t1">${stationData[i]?.Station_Name} <span class="t1-state-text">(${stationData[i]?.Station_State_Text})</span></div><div class="sub">${stationData[i]?.Station_Sido} ${stationData[i]?.Station_Gugun} ${stationData[i]?.Station_Dong} ${stationData[i]?.Station_Address}</div>`
            }
            kakao.maps.event.addListener(marker, 'click', searchDetailAddrFromCoords)
        }
        //#endregion
    }

    return (
        <>
            <div className="goback" onClick={() => (document.referrer ? navigate(-1) : navigate(URL.HOME.MAIN))}>
                <img className="back" src={require('../../assets/images/back-button.png')} alt="" />
                <div className="t1">뒤로가기</div>
            </div>
            <div id="map"></div>
        </>
    )
}

export default NetworkGoStation
